export default __webpack_public_path__ + "static/media/Twitter.a137f936.svg";